<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col
        :span="4"
        class="cs-main-left-container"
      >
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">校区管理</span>
                <el-row class="grid-content">
                  <el-col>
                    <pagination v-loading="loading" :data="listData" @loadData="onListDataLoad" :option="paginationOption" @search="onSearch" @add="onAdd" @edit="onEdit" @delete="onDelete"></pagination>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :center="true"
      :close-on-click-modal="false"
      width="600px"
      :visible.sync="dialogEditorVisible"
      top="5vh"
    >
      <campusEditor
        :options="editOptions"
        :dataIn="editData"
        @closeDialog="onEditClose"
        @saveSuccess="onEditSaveSuccess"
      ></campusEditor>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.grid-content {
    /deep/ .el-table .cell {
      white-space: pre-line;
    }
}
</style>

<script>
import global_ from "@/core/global";
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import campusEditor from "../../components/campusEditor";

import {
  getCampusPageList,
  removeCampus
} from "../../service/common.service";

export default {
  data() {
    return {
      loading: false,
      listData: {},
      paginationOption: {},
      editOptions: {
        basicEditable: true
      },
      editData: {},
      editIndex: -1,
      dialogEditorVisible: false,
      searchKeyword: "",
      pageSize: 20
    };
  },
  components: {
    navigator,
    pagination,
    campusEditor
  },
  created(){
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: true,
      editButtonText: "编辑",
      hasAddButton: !this.USERMANAGER.isExecutiveManager,
      addButtonText: "添加",
      hasDeleteButton: !this.USERMANAGER.isExecutiveManager,
      hasSearch: false,
      hasEnableButton: false
    };
    this.editOptions = {
      basicEditable: !this.USERMANAGER.isExecutiveManager
    };
    this.search();
  },
  mounted() {
    
  },
  methods: {
    onAdd(){
      let newData = {
        Id: 0,
        Name: "",
        Longitude: 0,
        Latitude: 0,
        Timezone: "",
        CampusTimeSchedules: []
      };

      let startTimeText = "8:00 AM";
      let endTimeText = "11:00 PM";
      for (let i = 1; i <= 7; i++) {
        newData.CampusTimeSchedules.push({
          Id: 0,
          CampusId: 0,
          DayOfWeek: i,
          StartTimeText: startTimeText,
          EndTimeText: endTimeText
        });
      }

      this.editData = newData;
      this.dialogEditorVisible = true;
    },
    onEdit(index, row) {
      this.editIndex = index;
      this.editData = row;
      this.dialogEditorVisible = true;
    },
    onDelete(index, row) {
      if (!!row) {
        this.$confirm("您确定要删除该校区吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if (!row.Id) {
              this.deleteRow(index);
            } else {
              removeCampus(row.Id).then(result => {
                if (result.success) {
                  this.deleteRow(index);
                } else {
                  this.$message.error(result.message);
                }
              });
            }
          })
          .catch(() => {});
      }
    },
    deleteRow(index) {
      if (index >= 0 && index < this.listData.Results.length) {
        this.$delete(this.listData.Results, index);
      }
    },
    onSearch(keyword) {
      this.searchKeyword = keyword;
      this.search();
    },
    onListDataLoad(pageData) {
      this.search(pageData.pageNumber);
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.searchKeyword,
        startDate: "",
        endDate: "",
      };
      return pageData;
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.getListData(pageData);
    },
    getListData(pageData) {
      this.loading = true;

      getCampusPageList(pageData).then(result => {
        if (result && result.success) {
          this.listData = result.data;
        }
        this.loading = false;
      });
    },
    onEditClose() {
      this.dialogEditorVisible = false;
    },
    onEditSaveSuccess() {
      this.search();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/admin/campusList.vue